<template>
	<div>
		<div class="row">
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.id_fornecedor != null}"
			>
				<label>* {{ _traducao('global', 'fornecedor') }}:</label>
				<div style="display: flex">
					<select
						class="form-control"
						v-model="form.id_fornecedor"
						@change="carregaContratos(form.id_fornecedor)"
					>
						<option
							v-for="fornecedor in fornecedores"
							:key="fornecedor.id"
							:value="fornecedor.id"
						>
							{{ fornecedor.razao_social }}
						</option>
					</select>
				</div>
				<p class="help-block" v-if="form.erro.id_fornecedor != null">
					{{ form.erro.id_fornecedor }}
				</p>
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.id_contrato != null}"
			>
				<label>* {{ _traducao('global', 'contratos') }}:</label>
				<div style="display: flex">
					<select
						class="form-control"
						v-model="form.id_contrato"
						@change="carregaEmpenhos(form.id_contrato)"
						:disabled="form.id_fornecedor == null"
					>
						<option
							v-for="contrato in form.contratos"
							:key="contrato.id"
							:value="contrato.id"
						>
							{{ contrato.descricao }}
						</option>
					</select>
				</div>
				<p class="help-block" v-if="form.erro.id_contrato != null">
					{{ form.erro.id_contrato }}
				</p>
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.id_contrato_empenho != null}"
			>
				<label>* {{ _traducao('global', 'empenhos') }}:</label>
				<div style="display: flex">
					<select
						class="form-control"
						v-model="form.id_contrato_empenho"
						:disabled="Object.keys(form.contratoSelecionado).length <= 0"
						@change="preencherOrgao(form.id_contrato_empenho)"
					>
						<option
							v-for="empenho in form.empenhos"
							:key="empenho.id"
							:value="empenho.id"
						>
							{{ empenho.numero_empenho }}
						</option>
					</select>
				</div>
				<p class="help-block" v-if="form.erro.id_contrato_empenho != null">
					{{ form.erro.id_contrato_empenho }}
				</p>
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				v-if="
					form.contratoSelecionado.forma_controle == '' ||
					form.contratoSelecionado.forma_controle == 'L'
				"
			>
				<label> {{ _traducao('global', 'volume') }}:</label>
				<input
					v-model="form.empenhoSelecionado.litros_empenhados"
					class="form-control"
					disabled
				/>
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				v-if="form.contratoSelecionado.forma_controle == 'V'"
			>
				<label> {{ _traducao('global', 'valorReais') }}:</label>
				<input
					v-model="form.empenhoSelecionado.valor"
					class="form-control"
					disabled
				/>
			</div>
		</div>
		<div class="row">
			<div
				class="col-xs-12 col-sm-3 form-group"
				v-if="
					form.contratoSelecionado.forma_controle == '' ||
					form.contratoSelecionado.forma_controle == 'L'
				"
			>
				<label> {{ _traducao('global', 'litrosProcessados') }}:</label>
				<input
					v-model="form.empenhoSelecionado.litros_processados"
					class="form-control"
					disabled
				/>
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				v-if="form.contratoSelecionado.forma_controle == 'V'"
			>
				<label> {{ _traducao('global', 'valorProcessado') }} (R$):</label>
				<input
					v-model="form.empenhoSelecionado.valor_processado"
					class="form-control"
					disabled
				/>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label> {{ _traducao('global', 'combustivel') }}:</label>
				<input
					v-model="form.empenhoSelecionado.descricao_combustivel"
					class="form-control"
					disabled
					v-if="form.empenhoSelecionado.id_combustivel"
				/>
				<div style="display: flex">
					<select
						v-if="!form.empenhoSelecionado.id_combustivel"
						class="form-control"
						v-model="form.id_combustivel"
					>
						<option
							v-for="combustivel in form.combustiveis"
							:key="combustivel.id"
							:value="combustivel.id"
						>
							{{ combustivel.descricao }}
						</option>
					</select>
				</div>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label
					>{{
						_traducao('global', 'capacidadeMaximaMovimentacaoCombustivel')
					}}:</label
				>
				<input v-model="aeronave.tanque" class="form-control" disabled />
			</div>
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.volume != null}"
			>
				<label>* {{ _traducao('global', 'volume') }}:</label>
				<money
					v-model="form.volume"
					v-bind="_vpercem(1)"
					class="form-control text-right input-sm"
				/>
				<p class="help-block" v-if="form.erro.volume != null">
					{{ form.erro.volume }}
				</p>
			</div>
		</div>
		<div class="row">
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.valor_unitario != null}"
			>
				<label>* {{ _traducao('global', 'valorUnitario') }}:</label>
				<money
					v-model="form.valor_unitario"
					v-bind="_vmoneyCombustivel"
					class="form-control input-sm"
					@input="
						(valor_unitario) =>	calculaValorTotal()
					"
				/>
				<p class="help-block" v-if="form.erro.valor_unitario != null">
					{{ form.erro.valor_unitario }}
				</p>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label>* {{ _traducao('global', 'valorTotal') }}:</label>
				<money
					v-model="form.valor_total"
					disabled
					v-bind="_vmoneyCombustivel"
					class="form-control input-sm"
				/>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label> {{ _traducao('global', 'notaFiscal') }}:</label>
				<input v-model="form.nota_fiscal" class="form-control" />
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<div class="input-group">
					<input-select
						:label="campoOrgao ? campoOrgao : _traducao('global', 'orgaos')"
						:opcoes-objeto="orgaos"
						v-model="form.id_orgao"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {isObject} from 'lodash'

export default {
	name: 'MovimentacaoAvc',
	props: {
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		campoOrgao: {
			type: String,
			required: false,
			default: null
		},
		fornecedores: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		movimentacao: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		orgaos: {
			default() {
				return []
			},
			type: Array,
			required: true
		}
	},
	data() {
		return {
			form: {}
		}
	},
	watch: {
		movimentacao: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.form = this.movimentacao
				}
			}
		}
	},
	methods: {
		carregaContratos(id_fornecedor) {
			this.$emit('carrega-contratos', id_fornecedor)
		},
		carregaEmpenhos(id_contrato) {
			this.$emit('carrega-empenhos', id_contrato)
		},
		preencherOrgao(id_contrato_empenho) {
			this.$emit('preencher-orgao', id_contrato_empenho)
		},

		calculaValorTotal() {
			this.form.valor_total = this.form.valor_unitario * this.form.volume
		},

		verificaValorTransferirValorUnitario(value) {
			const valorTransferivel =
				Number(this.form.empenhoSelecionado.valor) -
				Number(this.form.empenhoSelecionado.valor_processado)
			let possivelValor = this.form.volume * value

			if (possivelValor > valorTransferivel) {
				this.form.valor_total = valorTransferivel
				this.form.valor_unitario = valorTransferivel / this.form.volume
			} else {
				this.form.valor_total = value * this.form.volume
			}
		},

		async validadorFormAbastecimentoAvc(index) {
			if (await this.validaMovimentacaoAvc()) {
				this.$emit('abastecimento-avc-valido', this.form, index)
			} else {
				this.$emit('abastecimento-avc-invalido', false)
			}
		},

		async validaMovimentacaoAvc() {
			var passou = true
			var obrigatorio = this._traducao('global', 'obrigacao')
			if (this.form.id_fornecedor == null) {
				this.form.erro.id_fornecedor = obrigatorio
				passou = false
			} else {
				this.form.erro.id_fornecedor = null
			}

			if (this.form.id_contrato == null) {
				this.form.erro.id_contrato = obrigatorio
				passou = false
			} else {
				this.form.erro.id_contrato = null
			}

			if (this.form.id_contrato_empenho == null) {
				this.form.erro.id_contrato_empenho = obrigatorio
				passou = false
			} else {
				this.form.erro.id_contrato_empenho = null
			}

			if (this.form.volume <= null) {
				this.form.erro.volume = obrigatorio
				passou = false
			} else if (
				this.form.volume - this.form.volumeAntesEdicao >
					this.form.empenhoSelecionado.litros_empenhados -
						this.form.empenhoSelecionado.litros_processados &&
				this.form.empenhoSelecionado?.id !== undefined && this.form.empenhoSelecionadoAntesEdicao?.id !== undefined &&
				this.form.empenhoSelecionado.id ==
					this.form.empenhoSelecionadoAntesEdicao.id &&
				(this.form.contratoSelecionado.forma_controle == '' ||
					this.form.contratoSelecionado.forma_controle == 'L')
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueDisponivelContrato'
				)
				passou = false
			}  else if (
				this.form.volume >
					this.form.empenhoSelecionado.litros_empenhados -
						this.form.empenhoSelecionado.litros_processados &&
				this.form.empenhoSelecionadoAntesEdicao?.id !== undefined && this.form.empenhoSelecionado?.id !== undefined &&
				this.form.empenhoSelecionado.id !=
					this.form.empenhoSelecionadoAntesEdicao.id &&
				(this.form.contratoSelecionado.forma_controle == '' ||
					this.form.contratoSelecionado.forma_controle == 'L')
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueDisponivelContrato'
				)
				passou = false
			} else if (
				this.form.valor_total - Number(this.form.valorTotalAntesEdicao) >
					this.form.empenhoSelecionado.valor -
						this.form.empenhoSelecionado.valor_processado &&
				this.form.empenhoSelecionado.id ==
					this.form.empenhoSelecionadoAntesEdicao.id &&
				this.form.contratoSelecionado.forma_controle == 'V'
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'valorMaiorQueDisponivelContrato'
				)
				passou = false
			} else if (
				this.form.valor_total >
					this.form.empenhoSelecionado.valor -
						this.form.empenhoSelecionado.valor_processado &&
				this.form.empenhoSelecionado.id !=
					this.form.empenhoSelecionadoAntesEdicao.id &&
				this.form.contratoSelecionado.forma_controle == 'V'
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'valorMaiorQueDisponivelContrato'
				)
				passou = false
			} else if (this.form.volume > this.aeronave.tanque) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueTanqueAeronave'
				)
				passou = false
			} else {
				this.form.erro.volume = null
			}

			if (this.form.valor_unitario < 0) {
				this.form.erro.valor_unitario = obrigatorio
				this.form.erro.valor_total = obrigatorio
				passou = false
			} else {
				this.form.erro.valor_unitario = null
				this.form.erro.valor_total = null
			}

			return passou
		}
	}
}
</script>

<style scoped></style>